module.exports = __webpack_public_path__ + "img/yd4@2x.fbfc3b82.png";